import { Search as SearchIcon } from '@mui/icons-material';

const Search = (): JSX.Element => <SearchIcon fontSize="inherit" />;

export default Search;
